import { createVNode as _createVNode2 } from "vue";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-dee23d7e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "wrap"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 新增下级团队 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("关联销售团队");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 删除 ");

import { computed, nextTick, ref, reactive } from 'vue';
import { useStore } from 'vuex';
import { getStructureTreeInfo, deleteDept } from '@/request';
import { useRoute } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import AddChildTeamModal from './component/AddChildTeamModal.vue';
import RelatedPersonnel from './component/RelatedPersonnel.vue';
import SellingDrugs from './component/SellingDrugs.vue';
import OrderAudit from '../OrderAudit/OrderAudit@3.0.vue';
import AfterSalesAudit from '../OrderAudit/AfterSalesAudit@3.0.vue';
import RelateTeamModal from './component/relateTeamModal.vue';
import DispatchConfig from './component/DispatchConfig.vue';
import PointsConfig from './component/pointsConfig.vue';
import NetPlatformConfig from './component/netplatformConfig.vue';
export default {
  name: 'BusinessManage@3.0',

  setup(__props) {
    const SUPPLIER_CATEGORY = {
      厂家团队: '1',
      销售团队: '2',
      共享团队: '3'
    };
    const storeVuex = useStore();
    const userType = computed(() => storeVuex.state.user.userType);
    const route = useRoute();
    const supplierId = route.query.supplierId;
    const storeType = route.query.storeType;
    const treeData = ref([]);
    const actDept = ref(null);
    const showAddChildTeamModal = ref(false);
    const isEdit = ref(false);
    const expandedKeys = ref([]);
    const treeRef = ref();
    const tab = ref('first');
    const rootStructureName = computed(() => {
      const root = treeData.value[0];

      if (!root) {
        return '';
      }

      const name = root.structureName || root.text || '';
      return String(name).replace(/\(\S+\)/, '').trim();
    });

    function initTreeData() {
      getStructureTreeInfo({
        supplierId,
        __repeat: true
      }).then(data => {
        if (data !== null && data !== void 0 && data.length) {
          data.forEach(item => _formatTreeData(item));
          treeData.value = data;
          nextTick(() => {
            // 默认初始化根节点数据
            actDept.value = treeRef.value.getNode(data[0].id);
          });
        }
      });
    }

    function _formatTreeData(item) {
      if (item.children && item.children.length) {
        item.children.forEach(v => {
          v.factorySupplierId = item.supplierId;
          v.factoryStructureId = item.id;

          _formatTreeData(v);
        });
      }
    }

    initTreeData();

    function renderContent(h, {
      node,
      data,
      store
    }) {
      let {
        supplierCategory
      } = data;
      let tagName = supplierCategory === 1 ? '国' : '销';
      return _createVNode2("span", {
        "class": "custom-tree-node"
      }, [_createVNode2("span", {
        "class": "tree-text"
      }, [node.label]), _createVNode2("span", {
        "class": `tree-tag tag-${supplierCategory}`
      }, [tagName])]);
    }

    const disabledAdd = computed(() => {
      if (storeType === SUPPLIER_CATEGORY['厂家团队']) {
        return !actDept.value || Number(actDept.value.data.levelType) >= 2 || getIsSaleTeam(String(actDept.value.data.supplierCategory));
      }

      return !actDept.value || Number(actDept.value.data.levelType) >= 2;
    });
    const disabledEdit = computed(() => {
      if (storeType === SUPPLIER_CATEGORY['厂家团队']) {
        return !actDept.value || Number(actDept.value.data.levelType) === 0 || getIsSaleTeam(String(actDept.value.data.supplierCategory));
      }

      return !actDept.value || Number(actDept.value.data.levelType) === 0;
    });
    const disabledDel = computed(() => {
      if (storeType === SUPPLIER_CATEGORY['厂家团队']) {
        return !actDept.value || Number(actDept.value.data.levelType) === 0 || getIsSaleTeam(String(actDept.value.data.supplierCategory));
      }

      return !actDept.value || Number(actDept.value.data.levelType) === 0;
    });
    const disabledRelative = computed(() => !actDept.value || String(actDept.value.data.supplierCategory) !== SUPPLIER_CATEGORY['厂家团队']);
    const disabledDispatch = computed(() => !actDept.value || Number(actDept.value.data.levelType) >= 1); // 可售药品disabled 省代内勤不可维护省代药品品种

    const disabledTabSaleProd = computed(() => {
      if (userType.value === 3) {
        // if (storeType === SUPPLIER_CATEGORY['厂家团队']) {
        //   return !actDept.value || getIsSaleTeam(String(actDept.value.data.supplierCategory));
        // }
        // return !actDept.value || Number(actDept.value.data.levelType) === 0;
        return false;
      }

      if (isSaleTeam.value) return false;
      return !actDept.value || getIsSaleTeam(String(actDept.value.data.supplierCategory));
    }); // 订单审核disabled

    const disabledTabAuditOrder = computed(() => {
      if (isSaleTeam.value) {
        return !actDept.value || Number(actDept.value.data.levelType) >= 1;
      }

      return !actDept.value || String(actDept.value.data.supplierCategory) === SUPPLIER_CATEGORY['厂家团队'];
    }); // 是否销售型团队

    const isSaleTeam = computed(() => storeType === SUPPLIER_CATEGORY['销售团队'] || storeType === SUPPLIER_CATEGORY['共享团队']);

    function getIsSaleTeam(type) {
      return type === SUPPLIER_CATEGORY['销售团队'] || type === SUPPLIER_CATEGORY['共享团队'];
    }

    function selectTreeNode(node, treeNode) {
      actDept.value = treeNode;
      tab.value = 'first';
    }

    function add() {
      isEdit.value = false;
      showAddChildTeamModal.value = true;
    }

    function edit() {
      isEdit.value = true;
      showAddChildTeamModal.value = true;
    }

    function del() {
      ElMessageBox.confirm('是否确认删除该团队?', '确认删除').then(() => {
        deleteDept({
          structureId: actDept.value.data.id,
          __warn: true,
          __repeat: true
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            initTreeData();
          }
        });
      });
    } // 关联销售团队modal


    const relateTeamModal = reactive({
      visible: false,
      relateTeamList: []
    });

    function showRelateTeamModalHandle() {
      relateTeamModal.visible = true;
    } // 可售药品库存是否为显示为库位库存


    const storageType = ref(0); // 0:库存  1:库位库存

    function storageTypeChange(v) {
      storageType.value = v;
    }

    function tabChangeHandle() {
      // 强制设置select样式
      nextTick(() => {
        let remoteSelect = document.querySelector('.remote-select');
        let tagsElHeight = remoteSelect.querySelector('.el-select-tags-wrapper').clientHeight;
        remoteSelect.querySelector('.el-input__inner').style.height = parseInt(tagsElHeight + 30) + 'px';
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      const _component_el_scrollbar = _resolveComponent("el-scrollbar");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
        height: "100%",
        class: _normalizeClass(["org-wrap", {
          small: _unref(isSaleTeam)
        }])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          "model-value": "first"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Plus",
              size: "small",
              disabled: _unref(disabledAdd),
              onClick: add
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            }, 8, ["disabled"]), _unref(storeType) == 1 ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "small",
              disabled: _unref(disabledRelative),
              onClick: showRelateTeamModalHandle
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
              type: "success",
              icon: "Edit",
              size: "small",
              disabled: _unref(disabledEdit),
              onClick: edit
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 1
            }, 8, ["disabled"]), _createVNode(_component_el_button, {
              type: "danger",
              icon: "Delete",
              size: "small",
              disabled: _unref(disabledDel),
              onClick: del
            }, {
              default: _withCtx(() => [_hoisted_5]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "组织结构",
            name: "first"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tree, {
              style: {
                "margin-top": "10px"
              },
              data: treeData.value,
              "highlight-current": true,
              "expand-on-click-node": false,
              "node-key": "id",
              ref_key: "treeRef",
              ref: treeRef,
              props: {
                label: 'text',
                children: 'children'
              },
              onNodeClick: selectTreeNode,
              "render-content": renderContent
            }, null, 8, ["data"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["class"]), _createVNode(_component_el_scrollbar, {
        height: "100%",
        class: _normalizeClass(["view-wrap", {
          small: _unref(isSaleTeam)
        }])
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => tab.value = $event),
          type: "card",
          onTabChange: tabChangeHandle
        }, {
          default: _withCtx(() => {
            var _actDept$value6;

            return [_createVNode(_component_el_tab_pane, {
              label: "关联人员",
              name: "first"
            }, {
              default: _withCtx(() => {
                var _actDept$value;

                return [actDept.value && tab.value === 'first' ? (_openBlock(), _createBlock(RelatedPersonnel, {
                  key: 0,
                  dept: (_actDept$value = actDept.value) === null || _actDept$value === void 0 ? void 0 : _actDept$value.data,
                  supplierId: _unref(supplierId)
                }, null, 8, ["dept", "supplierId"])) : _createCommentVNode("", true)];
              }),
              _: 1
            }), _createVNode(_component_el_tab_pane, {
              label: "可售药品",
              name: "first2",
              disabled: _unref(disabledTabSaleProd)
            }, {
              default: _withCtx(() => {
                var _actDept$value2;

                return [actDept.value && tab.value === 'first2' ? (_openBlock(), _createBlock(SellingDrugs, {
                  key: 0,
                  dept: (_actDept$value2 = actDept.value) === null || _actDept$value2 === void 0 ? void 0 : _actDept$value2.data,
                  supplierId: _unref(supplierId),
                  storageType: storageType.value
                }, null, 8, ["dept", "supplierId", "storageType"])) : _createCommentVNode("", true)];
              }),
              _: 1
            }, 8, ["disabled"]), _createVNode(_component_el_tab_pane, {
              label: "售后审核",
              name: "first3a",
              disabled: _unref(disabledTabAuditOrder)
            }, {
              default: _withCtx(() => {
                var _actDept$value3;

                return [actDept.value && tab.value === 'first3a' ? (_openBlock(), _createBlock(AfterSalesAudit, {
                  key: 0,
                  actDept: (_actDept$value3 = actDept.value) === null || _actDept$value3 === void 0 ? void 0 : _actDept$value3.data
                }, null, 8, ["actDept"])) : _createCommentVNode("", true)];
              }),
              _: 1
            }, 8, ["disabled"]), _createVNode(_component_el_tab_pane, {
              label: "订单审核",
              name: "first3",
              disabled: _unref(disabledTabAuditOrder)
            }, {
              default: _withCtx(() => {
                var _actDept$value4;

                return [actDept.value && tab.value === 'first3' ? (_openBlock(), _createBlock(OrderAudit, {
                  key: 0,
                  actDept: (_actDept$value4 = actDept.value) === null || _actDept$value4 === void 0 ? void 0 : _actDept$value4.data
                }, null, 8, ["actDept"])) : _createCommentVNode("", true)];
              }),
              _: 1
            }, 8, ["disabled"]), _unref(isSaleTeam) ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "基础设置",
              name: "first4"
            }, {
              default: _withCtx(() => {
                var _actDept$value5;

                return [_createVNode(DispatchConfig, {
                  actDept: (_actDept$value5 = actDept.value) === null || _actDept$value5 === void 0 ? void 0 : _actDept$value5.data,
                  onSetStorageType: storageTypeChange
                }, null, 8, ["actDept"])];
              }),
              _: 1
            })) : _createCommentVNode("", true), _unref(userType) == '2' && !_unref(isSaleTeam) && ((_actDept$value6 = actDept.value) === null || _actDept$value6 === void 0 ? void 0 : _actDept$value6.data.levelType) == 0 ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 1,
              label: "挂网服务配置",
              name: "first5"
            }, {
              default: _withCtx(() => {
                var _actDept$value7;

                return [actDept.value && tab.value === 'first5' ? (_openBlock(), _createBlock(NetPlatformConfig, {
                  key: 0,
                  actDept: (_actDept$value7 = actDept.value) === null || _actDept$value7 === void 0 ? void 0 : _actDept$value7.data
                }, null, 8, ["actDept"])) : _createCommentVNode("", true)];
              }),
              _: 1
            })) : _createCommentVNode("", true), _unref(storeType) === SUPPLIER_CATEGORY['共享团队'] ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 2,
              label: "设置积分",
              name: "first5",
              disabled: _unref(disabledDispatch)
            }, {
              default: _withCtx(() => [tab.value === 'first5' ? (_openBlock(), _createBlock(PointsConfig, {
                key: 0
              })) : _createCommentVNode("", true)]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true)];
          }),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["class"]), _createVNode(AddChildTeamModal, {
        modelValue: showAddChildTeamModal.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => showAddChildTeamModal.value = $event),
        actDept: actDept.value,
        supplierId: _unref(supplierId),
        isEdit: isEdit.value,
        rootStructureName: _unref(rootStructureName),
        onSuccess: initTreeData
      }, null, 8, ["modelValue", "actDept", "supplierId", "isEdit", "rootStructureName"]), _createVNode(RelateTeamModal, {
        modelValue: relateTeamModal.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => relateTeamModal.visible = $event),
        relateTeamList: relateTeamModal.relateTeamList,
        actDept: actDept.value,
        onSuccess: initTreeData
      }, null, 8, ["modelValue", "relateTeamList", "actDept"])]);
    };
  }

};